module.exports = __webpack_public_path__ + "img/museo-agua.d0c967d6.jpg";